export const header = [
    {
        path: 'news-feed-layout/style-1',
        icons: 'file',
        iconType: 'feather',
        active: true
    },
    {
        path: 'favorite/page-home',
        icons: 'star',
        iconType: 'feather'
    },
    {
        path: '',
        icons: 'users',
        iconType: 'feather'
    },
    {
        path: 'others/music',
        icons: 'headphones',
        iconType: 'feather'
    },
    {
        path: 'others/weather',
        icons: 'cloud',
        iconType: 'feather'
    },
    {
        path: 'others/event-calendar',
        icons: 'calendar',
        iconType: 'feather'
    },
    {
        path: 'others/birthday',
        icons: 'cake',
        class: 'bar-icon fill-white'
    },
    {
        path: 'others/games',
        icons: 'game-controller',
        class: 'bar-icon fill-white'
    },
]